import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { JobCard } from "./JobsList";
import {SolidPlay} from "./AutoPlay";


export  default function SolidFutureJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

 
  useEffect(() => {
    
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "jobs?per_page=8&solid_future=1", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setJobs(res.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  // let computedSlidesToShow = Math.min(jobs.length, 5) || 1;

  // if (jobs.length > 1 && jobs.length <= 5) {
  // computedSlidesToShow = jobs.length - 1;
  // }

  //  const futurejobs = {
  //   dots: false,
  //   arrows: false,
  //   infinite: jobs.length > computedSlidesToShow,
  //   slidesToShow: computedSlidesToShow,
  //   slidesToScroll: 1,
  //   autoplay: jobs.length > computedSlidesToShow,
  //   // speed: 2000,
  //   autoplaySpeed: 5000,
  //   // cssEase: "linear"
  // };

    const getBreakpointSettings = (maxSlidesForScreen) => {
    // 1. Cap it at the maximum allowed for this screen size or total jobs
    let computedSlides = Math.min(jobs.length, maxSlidesForScreen) || 1;

    // 2. Apply your forced-scroll deduction rule
    if (jobs.length > 1 && jobs.length <= maxSlidesForScreen) {
      computedSlides = jobs.length - 1;
    }

    const shouldScroll = jobs.length > computedSlides;

    return {
      slidesToShow: computedSlides,
      infinite: shouldScroll,
      autoplay: shouldScroll,
    };
  };

  // Base settings for desktop (Max 5 slides)
  const desktopSettings = getBreakpointSettings(5);

  const futurejobs = {
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    
    // Spread desktop calculations
    slidesToShow: desktopSettings.slidesToShow,
    infinite: desktopSettings.infinite,
    autoplay: desktopSettings.autoplay,

    responsive: [
      {
        breakpoint: 992, // Tablets/Small Laptops (Max 3 slides)
        settings: {
          ...getBreakpointSettings(3),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768, // Small Tablets (Max 2 slides)
        settings: {
          ...getBreakpointSettings(2),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575, // Mobile Phones (Max 1 slide)
        settings: {
          ...getBreakpointSettings(1),
          slidesToScroll: 1,
        }
      }
    ]
  };

  if (!loading && jobs.length === 0) return null;

  return (
    <section className="sf-section sf-section-purple sf-training-jobs">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title text-white">Solid Future Hiring</h2>
        </div>
          <Link key="2688" to='/company/solid_future' className="btn btn-light btn-sm btn_current_open">
            Explore current opening <i className="fa fa-chevron-right" />
          </Link>

        {loading ? (
          <div className="sf-loading" style={{ color: "rgba(255,255,255,.7)" }}>
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : jobs.length > 0 ? (
          // <div className="sf-jobs-grid">
            <SolidPlay futurejobs={futurejobs}>
            {jobs.map((job) => (
              <JobCard key={job.id} job={job} />
            ))}
            </SolidPlay>
          // </div>
        ) : (
         <div className="sf-empty">No jobs in this category.</div>
        )}
        
      </div>
    </section>
  );
}


export  function SolidFutureJobGrouped({ title, size, extraParams }) {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedEmployer, setExpandedEmployer] = useState(null);

  const perPage = size || 8;
  const extra = extraParams || {};

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const params = new URLSearchParams({ per_page: perPage, solid_future: 1, ...extra });
    axios
      .get(constvar.api_url + "jobs/grouped?" + params.toString(), {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setEmployers(res.data.data.data || []);
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [perPage, JSON.stringify(extra)]);

  const handleEmployerHover = (employerId) => {
    setExpandedEmployer(employerId);
  };

  const handleEmployerLeave = () => {
    setExpandedEmployer(null);
  };

  return (
    <section className="sf-section sf-section-purple">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title text-white">Solid Future Hiring</h2>

        </div>
          <Link key="2688" to='/company/solid-future' className="btn btn-light btn-sm btn_current_open">
            Explore current opening <i className="fa fa-chevron-right" />
          </Link>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : employers.length > 0 ? (
          <div className="sf-groupby-employers-grid">
            {employers.map((employer) => {
              const isExpanded = expandedEmployer === employer.employer_id;
              const visibleJobs = isExpanded ? employer.jobs.slice(0, 7) : employer.jobs.slice(0, 2);
              const hasMoreJobs = employer.jobs.length > 2;
              const remainingCount = employer.jobs.length - 2;

              return (
                <div className="jobs_card">
                  <div
                    key={employer.employer_id}
                    className={`sf-groupby-employer-card ${isExpanded ? "sf-groupby-employer-card-expanded" : ""}`}
                    onMouseEnter={() => handleEmployerHover(employer.employer_id)}
                    onMouseLeave={handleEmployerLeave}
                  >
                    <div className="flex justify-between">
                      {/* Employer Header */}
                      <div className="sf-groupby-employer-header">
                        <div className="sf-groupby-employer-logo-wrapper">
                          <img
                            src={
                              employer.photo ||
                              "/default/default_company_logo.jpg"
                            }
                            alt={employer.comp_name}
                            className="sf-groupby-employer-logo"
                          />
                        </div>
                        <div className="sf-groupby-employer-name">
                          <h5><Link key={employer.employer_id} to={`/company/${employer.clientslug}`} className="sf-groupby-employer-name-link">{employer.comp_name || "N/A"}</Link></h5>
                          {visibleJobs.map((job) => (
                            <Link
                              key={job.id}
                              to={"/jobs/" + job.slug}
                              className="sf-groupby-employer-job-link"
                            >
                                {job.job_title.length > 25 
                                  ? `${job.job_title.substring(0, 25)}...` 
                                  : job.job_title
                                }
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* Expand Button - Show only if more than 2 jobs */}
                      {hasMoreJobs && (
                        <div className="sf-groupby-employer-expand-button">
                          <Link key={employer.employer_id} to={`/company/${employer.clientslug}`}>
                          <span className="sf-groupby-expand-text">
                          +{remainingCount} more
                          </span>
                          <i className="fa fa-chevron-down" />
                          </Link>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="sf-empty">No jobs available at the moment.</div>
        )}
      </div>
    </section>
  );
}